
import React, { useState, useEffect } from "react";
import { CDBTable, CDBTableHeader, CDBTableBody } from "cdbreact";
import Sidebar from "../../Sidebar";
import Navbar from "../../Navbar";
import {  Pagination, Form, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom'


import { TfiPencilAlt } from "react-icons/tfi";

const ListFees = () => {
  
const navigate=useNavigate();







  // update Enquiry 

const UpdateEnquirys=(Id)=>{

    navigate('/updateFees/'+Id)
}





   



 ///-------------------------------------------


//  List Of The Data
 
    const [category, setCategory] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);


    useEffect(() => {
      const getcategory = async () => {
        const res = await fetch("https://peapi.microtechsolutions.co.in/php/getfees.php");
        const getdata = await res.json();
        setCategory(getdata);
        console.log(getdata);
  
      };
  
      getcategory();
  
    }, []);

   


//pagignation 

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems  = category.slice(indexOfFirstItem, indexOfLastItem);
   

  
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

   
 
    const handleItemsPerPageChange = (e) => {
      const newItemsPerPage = parseInt(e.target.value, 10);
      if (!isNaN(newItemsPerPage) && newItemsPerPage > 0) {
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1); // Reset to the first page when changing items per page
      }
    };


 


  return (
    <div className="d-flex">
      <div>
        <Sidebar />
      </div>
      <div style={{ flex: "1 1 auto", display: "flex", flexFlow: "column", height: "100vh", overflowY: "hidden" }}>
        <Navbar />
        <div style={{ height: "100%" }}>
          <div style={{ padding: "20px 5%", height: "calc(100% - 80px)", overflowY: "scroll" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(1, minmax(200px, 1920))" }}>

            <Link exact to="/fees" activeClassName="activeClicked">
                            <button  style={{ marginLeft: '10px' }} className="btn btn-info" >Back</button>
                          </Link>
                
               
             
              <div className="mt-5">
                <h4 className="font-weight-bold mb-3">Fees List</h4>
                <Form>
        <Row className="mb-3">
          <Col xs="auto">
            <Form.Group controlId="formItemsPerPage">
              <Form.Label>Items per Page</Form.Label>
              
              <Form.Control
                type="number"
               min={1}
                placeholder="Enter items per page"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>

                <CDBTable responsive>
                  <CDBTableHeader color="dark">
                    <tr>
                      <th> ID</th>
                      <th>Student Id </th>
                      <th>Fees Date</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Fees</th>
                    
                      <th></th>
                      <th></th>
                      <th></th>

                    </tr>
                  </CDBTableHeader>
                  <CDBTableBody>



                    { currentItems.map((getcate) => (

                      <tr key={getcate.Id}>
                        <td>{getcate.Id}</td>
                        <td>{getcate.StudentId}</td>
                        <td>{(getcate.FeesDate.date).substring(0, 10)}</td>
                        <td>{getcate.Month}</td>
                        <td>{getcate.Year}</td>
                        <td>{getcate.Fees}</td>
                       

                    




                            


                                <td>
                            <button  onClick={()=>{ UpdateEnquirys(getcate.Id)}} style={{ marginLeft: '10px' }} className="btn btn-success" ><TfiPencilAlt /></button>
                        
                                </td>
                          
                                
                                     
                      </tr>
                    ))}


                  </CDBTableBody>
                </CDBTable>

               

              </div>
            

            </div>
            {/* <Pagination>
             {Array.from({ length: Math.ceil(category.length / itemsPerPage) }, (_, index) => (
             <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>
            {index + 1}
           </Pagination.Item>
        ))}
        </Pagination> */}
        <Row className="justify-content-center">
        <Col xs="auto">
          <Pagination>
            {Array.from({ length: Math.ceil(category.length / itemsPerPage) }, (_, index) => (
              <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </Col>
      
      </Row>
            <footer className="mx-auto my-3 text-center">
              <small>&copy; Microtech, 2023. All rights reserved.</small>
            </footer>
          </div>

        </div>
      </div>
    </div>
  );
};


export default ListFees;